var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isVer2)?_c('ClientEventProcedureItemV1',{attrs:{"event":_vm.event,"hideTitle":_vm.hideTitle}}):_vm._e(),(_vm.isVer2)?_c('ClientEventProcedureItemV2',{attrs:{"event":_vm.event,"hideTitle":_vm.hideTitle}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }